module.exports = __webpack_public_path__ + "img/UTGREE-3.d28124d6.jpg";